import { useRef } from 'react';

const EDGE_SIZE = 24;
const SWIPE_THRESHOLD = 60;

export const useGestureNavigation = ({ isOpen, onOpen, onClose }) => {
  const startRef = useRef(null);

  const handleTouchStart = (event) => {
    if (event.touches.length !== 1) {
      return;
    }

    const touch = event.touches[0];
    if (!isOpen && touch.clientX > EDGE_SIZE) {
      startRef.current = null;
      return;
    }

    startRef.current = {
      x: touch.clientX,
      y: touch.clientY,
    };
  };

  const handleTouchEnd = (event) => {
    if (!startRef.current || event.changedTouches.length !== 1) {
      startRef.current = null;
      return;
    }

    const touch = event.changedTouches[0];
    const deltaX = touch.clientX - startRef.current.x;
    const deltaY = touch.clientY - startRef.current.y;

    startRef.current = null;

    if (Math.abs(deltaX) < SWIPE_THRESHOLD || Math.abs(deltaX) < Math.abs(deltaY)) {
      return;
    }

    if (!isOpen && deltaX > 0) {
      if (navigator.vibrate) {
        navigator.vibrate(10);
      }
      onOpen();
    }

    if (isOpen && deltaX < 0) {
      if (navigator.vibrate) {
        navigator.vibrate(10);
      }
      onClose();
    }
  };

  const handleTouchCancel = () => {
    startRef.current = null;
  };

  return {
    onTouchStart: handleTouchStart,
    onTouchEnd: handleTouchEnd,
    onTouchCancel: handleTouchCancel,
  };
};
